import { getSharePage, getChannel, generateCourseNewAttachmentUrl } from '@/api'
import axios from 'axios'
import { Toast } from 'vant'
import moment from 'moment'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
import pdf from '../../components/pdf/pdf.vue'
export default {
  props: [],
  components: { pdf },
  name: 'share-page',
  data () {
    return {
      courseId: null,
      loading: false,
      qrcode: false,
      course: {},
      pageTemplate: [
        { title: '项目安排 Program Arrangement', key: 'cycle' },
        { title: '教授致辞 A WORD FROM THE INSTRUCTOR', key: 'teacherVedioUrl' },
        { title: '适合人群 Prerequisites', key: 'suggest' },
        { title: '导师介绍 Instructor Introduction', key: 'teacherDetail' },
        { title: '项目背景 Program Background', key: 'projectBackground' },
        { title: '项目介绍 Program Description', key: 'introduce' },
        { title: '导师二介绍 Instructor Information', key: 'dTeacherDetail' },
        // { title: '任职学校 University', key: 'teacherSchoolDetail' },
        { title: '项目大纲 Syllabus', key: 'courseOutlineDetail' },
        { title: '项目收获 Program Outcome', key: 'Schedule and Outcome' },
        { title: '可搭配项目', key: 'collocationProjects' }
        // { title: '时间安排与收获 Schedule and Outcome', key: 'Schedule and Outcome' }
      ],
      universitiesPageTemplate: [
        { title: '项目安排 Program Arrangement', key: 'cycle' },
        // { title: '教授致辞 A WORD FROM THE INSTRUCTOR', key: 'teacherVedioUrl' },
        // { title: '适合人群 Prerequisites', key: 'suggest' },
        // { title: '导师介绍 Instructor Introduction', key: 'teacherDetail' },
        { title: '项目背景 Program Background', key: 'projectBackground' },
        { title: '项目介绍 Program Description', key: 'introduce' }
        // { title: '导师二介绍 Instructor Information', key: 'dTeacherDetail' },
        // { title: '任职学校 University', key: 'teacherSchoolDetail' },
        // { title: '项目大纲 Syllabus', key: 'courseOutlineDetail' },
        // { title: '项目收获 Program Outcome', key: 'Schedule and Outcome' },
        // { title: '可搭配项目', key: 'collocationProjects' }
        // { title: '时间安排与收获 Schedule and Outcome', key: 'Schedule and Outcome' }
      ],
      courseOutlineDetail: [],
      textDataList: [],
      attachmentList: [],
      showpopup: false,
      typeId: -1,
      imgUrlList: [
        { imgUrl: require('@/assets/01.png') },
        { imgUrl: require('@/assets/02.png') },
        { imgUrl: require('@/assets/03.png') },
        { imgUrl: require('@/assets/04.png') },
        { imgUrl: require('@/assets/05.png') },
        { imgUrl: require('@/assets/06.png') }
      ],
      htmlTitle: 'pdf文件名',
      specialElementHandlers: {
        '#editor': function (element, renderer) {
          return true
        }
      },
      canvas: [],
      imglist1: [],
      imglist2: [],
      isIos: false,
      fromData: null,
      linkurl: null,
      schoolBegins: null,
      isUniversitiesH5: false
    }
  },
  computed: {
    // x: function() {}
  },
  watch: {},
  created () {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      this.isIos = true
    }
    const courseId = this.$route.query.id
    this.qrcode = this.$route.query.from === 'qrcode'
    this.fromData = this.$route.query.from
    if (courseId === undefined || courseId === null || courseId === '') {
      Toast({ message: '数据错误，请联系管理员检查', type: 'fail' })
    } else {
      this.courseId = courseId
    }
    if (this.$route.query.universities * 1 === 1) {
      this.isUniversitiesH5 = true
    }
    this.initData()
    if (this.fromData) {
      this.getChannellink()
    }
  },
  mounted () {},
  destroyed () { },
  methods: {
    checkImage () {
      const result = this.course.backgroundImgUrl ? `url('${this.course.backgroundImgUrl}')` : 'url(\'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/smallSearch/mobile/header-bg.jpg\')'
      return result
    },
    async getChannellink () {
      const { data, error } = await getChannel({ name: this.fromData })
      if (data && error.returnCode === 0) {
        this.linkurl = data.url
      }
    },
    async initData () {
      this.loading = true
      const { data } = await getSharePage(this.courseId, this.qrcode)
      this.course = data
      this.schoolBegins = this.course.schoolBegins
      this.typeId = data.typeId
      this.setWXShareInfo(data)
      // 高校h5页面跳转过来
      if (this.isUniversitiesH5) {
        this.universitiesFormatData(data)
      } else {
        this.formatData(data)
      }
      this.attInit(data)
      this.loading = false
      console.log('this.textDataList: ', this.textDataList)
    },
    // 高校h5条转
    universitiesFormatData (data) {
      for (const item of this.universitiesPageTemplate) {
        let { title, key } = item
        if (key === 'cycle') {
          const value = []
          let time = null
          if (data.schoolBegins) {
            time = moment(data.schoolBegins).format('YYYY-MM-DD') // .add(8, 'hour')
          } else {
            time = '待定'
          }
          value.push(this.formatEnter('开始日期: ' + time))
          if (data.cycle) {
            value.push(this.formatEnter('课时安排: ' + data.cycle))
          }
          if (data.position && (this.typeId * 1 === 5)) {
            value.push(this.formatEnter('营地地点: ' + data.position))
          }
          this.textDataList.push({ title, show: true, value })
        } else if (key === 'introduce' && data[key]) {
          if (this.course.typeId === 4) {
            title = '实验室研究方向介绍 Program Description'
          } else if (this.course.typeId === 45) {
            title = '实训项目介绍 Program Description'
          }
          this.textDataList.push({ title, show: true, value: [this.formatBrMargin(data[key])] })
        } else if (data[key]) {
          this.textDataList.push({ title, show: true, value: [this.formatBrMargin(data[key])] })
        }
      }
      // 附近查看定位附件部分
      if (this.$route.meta.isUpdate) {
        this.$nextTick(() => {
          const height = this.$refs.fileD.offsetTop
          document.body.scrollTop = height
          document.documentElement.scrollTop = height
        })
      }
    },
    formatData (data) {
      for (const item of this.pageTemplate) {
        let { title, key } = item
        if (key === 'cycle') {
          const value = []
          let time = null
          if (data.schoolBegins) {
            time = moment(data.schoolBegins).format('YYYY-MM-DD') // .add(8, 'hour')
          } else {
            time = '待定'
          }
          // 探索1v1新增项目类型56
          if (data.typeId !== 56) {
            value.push(this.formatEnter('开始日期: ' + time))
          }
          if (data.cycle) {
            value.push(this.formatEnter('课时安排: ' + data.cycle))
          }
          // aihub加地点
          if (data.position && (this.typeId * 1 === 5)) {
            value.push(this.formatEnter('营地地点: ' + data.position))
          }
          this.textDataList.push({ title, value })
        } else if (key === 'suggest') { // 适合人群
          const suggestList = ['suggestSenior', 'suggestCollege', 'suggestMaster', 'suggestMiddle']
          const suggestText = []
          // 只选大学生【显示大学生及以上】其他正常显示
          if (!data.suggestSenior && !data.suggestMaster && !data.suggestMiddle && data.suggestCollege) {
            suggestText.push('大学生及以上')
          } else {
            for (const _key of suggestList) {
              if (data[_key]) {
                suggestText.push(_key === 'suggestSenior' ? '高中生' : _key === 'suggestCollege' ? '大学生' : _key === 'suggestMaster' ? '研究生' : _key === 'suggestMiddle' ? '初中生' : null)
              }
            }
          }
          //   for (const _key of suggestList) { if (data[_key]) { suggestText.push(_key === 'suggestSenior' ? '高中生' : _key === 'suggestCollege' ? '大学生' : null) } }
          const value = []
          if (suggestText.length > 0) { value.push(this.formatEnter('适合年级 (Grade): ' + suggestText.join('/'))) }
          if (data.suggestBasics) { value.push(this.formatEnter('适合专业 (Major): ' + data.suggestBasics)) }
          if (data.foundationCourseName) {
            data.foundationCourseName = data.foundationCourseName.replace('专业选修课程：', '')
            value.push(this.formatEnter('建议选修: ' + data.foundationCourseName))
          }
          this.textDataList.push({ title, value })
        } else if (key === 'courseOutlineDetail' && data[key]) {
          if (this.course.typeId === 4 || this.course.typeId === 45) {
            title = '实训工作内容 Syllabus'
          }
          if (this.course.typeId === 45) {
            this.textDataList.push({ title, value: [data[key]] })
          } else {
            this.textDataList.push({ title, value: [this.formatEnter(data[key])] })
          }
          // this.courseOutlineDetail = this.formatEnterPdf(data[key])
        } else if (key === 'Schedule and Outcome') {
          const value = []
          if (data.output) { value.push(this.formatBrMargin(data.output, 1)) }
          this.textDataList.push({ title, value })
        } else if (key === 'teacherDetail' && data[key]) {
          let value = data[key]
          value = [this.formatBrMargin(value)]
          // 名校实验室
          const showSchool = (this.typeId * 1) === 4
          this.textDataList.push({ title, value, showSchool, teacher: { img: data.teacherHeadImgUrl, name: data.teacherName, level: data.teacherLevel, school: data.teacherSchool, teacherSchool: data.teacherSchoolDetail } })
        } else if (key === 'dTeacherDetail' && data[key]) {
          let value = data[key]
          value = [this.formatDTeahcerMargin(value)]
          this.textDataList.push({ title, value: value, teacher: { img: data.dTeacherHeaderImageUrl, name: data.dTeacherNickName, level: data.dTeacherLevel, school: data.dTeacherSchool } })
        } else if (key === 'introduce' && data[key]) {
          if (this.course.typeId === 4) {
            title = '实验室研究方向介绍 Program Description'
          } else if (this.course.typeId === 45) {
            title = '实训项目介绍 Program Description'
          }
          this.textDataList.push({ title, value: [this.formatBrMargin(data[key])] })
        } else if (data[key] && key === 'collocationProjects') {
          if (this.course.typeId === 45 && data[key] !== '<p><br></p>') {
            this.textDataList.push({ title, value: [this.formatBrMargin(data[key])] })
          }
        } else if (data[key]) {
          if (key !== 'projectBackground' || (this.course.typeId !== 4 && this.course.typeId !== 45)) {
            this.textDataList.push({ title, value: key === 'teacherVedioUrl' ? data[key] : [this.formatBrMargin(data[key])] })
          }
        }
      }
      for (const item of this.textDataList) {
        if (item.title === '项目背景 Program Background' && (this.typeId * 1 === 1)) {
          this.$set(item, 'show', false)
        } else {
          this.$set(item, 'show', true)
        }
      }
      // 附近查看定位附件部分
      if (this.$route.meta.isUpdate) {
        this.$nextTick(() => {
          const height = this.$refs.fileD.offsetTop
          document.body.scrollTop = height
          document.documentElement.scrollTop = height
        })
      }
    },
    formatDTeahcerMargin (data) {
      let result = ''
      if (data) {
        for (const item of data) {
          if (item && item !== '') {
            result += `<p class="format-style-margin-item">${item}</p>`
          }
        }
      }
      return result
    },
    // .无序列行
    formatBrMargin (data, type) {
      let result = ''
      if (data) {
        data = data.split('\n')
        data.forEach((item, index) => {
          if (type && (this.course.typeId * 1 !== 31)) {
            result += '<p class="format-style-margin-item getProject_box">' +
            `<span class="img${index}"></span>` +
            `<span class="getProject">${item}<span>
            </p>`
          } else {
            result += `<p class="format-style-margin-item">${item}</p>`
          }
        })
      }
      return result
    },
    formatEnterPdf (data) {
      let result = ''
      if (data) {
        data = data.split('\n')
        for (const item of data) {
          result += `<p >${item}</p>`
        }
      }
      return result
    },
    formatEnter (data) {
      let result = ''
      if (data) {
        data = data.split('\n')
        for (const item of data) {
          result += `<p class="format-style-list-item">${item}</p>`
        }
      }
      return result
    },
    attInit (data) {
      // console.log(data)
      // 项目大纲 courseOutlineUrl
      // 导师简历 teacherResumeUrl
      // 导师论作 teacherPaperUrl
      // 时间安排 scheduleUrl
      // 国际会刊发表展示 teacherInternationalJournalPaperUrl
      // 项目模式 projectModelUrl
      // 阅读材料 readingMaterialUrl 数组
      const result = []
      if (data.courseOutlineUrl) { result.push({ label: '项目大纲', url: data.courseOutlineUrl }) }
      if (data.teacherResumeUrl) { result.push({ label: '导师简历', url: data.teacherResumeUrl }) }
      if (data.teacherPaperUrl) { result.push({ label: '导师论作', url: data.teacherPaperUrl }) }
      if (data.scheduleUrl) { result.push({ label: '时间安排', url: data.scheduleUrl }) }
      if (data.teacherInternationalJournalPaperUrl) { result.push({ label: '国际会刊发表展示', url: data.teacherInternationalJournalPaperUrl }) }
      if (data.projectModelUrl) { result.push({ label: '项目模式', url: data.projectModelUrl }) }
      const readList = []
      if (data.readingMaterialUrl1) { readList.push(data.readingMaterialUrl1) }
      if (data.readingMaterialUrl2) { readList.push(data.readingMaterialUrl2) }
      if (data.readingMaterialUrl3) { readList.push(data.readingMaterialUrl3) }
      if (data.readingMaterialUrl4) { readList.push(data.readingMaterialUrl4) }
      if (data.readingMaterialUrl5) { readList.push(data.readingMaterialUrl5) }
      if (data.readingMaterialUrl6) { readList.push(data.readingMaterialUrl6) }
      if (data.readingMaterialUrl7) { readList.push(data.readingMaterialUrl7) }
      if (data.readingMaterialUrl8) { readList.push(data.readingMaterialUrl8) }
      if (data.readingMaterialUrl9) { readList.push(data.readingMaterialUrl9) }
      if (data.readingMaterialUrl10) { readList.push(data.readingMaterialUrl10) }
      if (readList.length > 0) {
        result.push({ label: '阅读材料', url: readList })
      }
      this.attachmentList = result
      // console.log(this.attachmentList)
    },
    async setWXShareInfo (data) {
      const currentRouter = this.$router.currentRoute.fullPath
      const basehref = `https://sou-m.gecacademy.cn${currentRouter}`
      const shareTitle = data.name
      const shareDesc = data.introduce
      // const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/smallSearch/share/share.jpeg'
      const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/smallSearch/share/share.jpeg'
      const shareInfo = {
        title: shareTitle,
        desc: shareDesc,
        link: basehref,
        imgUrl: this.course.backgroundImgUrl ? this.course.backgroundImgUrl : shareImgUrl,
        success () { },
        cancel () { }
      }
      const timestamp = parseInt(new Date() / 1000)
      const params = { timestamp, noncestr: 'test', url: encodeURIComponent(basehref), appName: 'gecFuwuhao' }
      // const result = await axios.get('https://api.gecacademy.cn/pay/wx/signature', { params })
      // const signature = result.data.data
      const result = await axios.post('https://gec-api.gecacademy.cn/souapi/wechat/sellTool/getSign', params)
      const signature = result.data.data.signature
      const wx = this.$wx
      await wx.configAsync({
        debug: false,
        appId: 'wxf88eda53c74e883f',
        timestamp,
        nonceStr: 'test',
        signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'chooseImage',
          'previewImage',
          'uploadImage',
          'chooseWXPay'
        ]
      })
      wx.onMenuShareTimeline(shareInfo)
      wx.onMenuShareAppMessage(shareInfo)
    },
    pdfClicked (item) {
      const url = item.url
      if (url.endsWith('.pdf')) {
        this.$router.push({ path: '/view', query: { url: item.url, title: item.str, desc: this.course.name, courseId: this.courseId, qrcode: this.qrcode } })
      } else {
        // this.$router.push({ path: '/jpgview', query: { url: item.url, title: item.label, desc: this.course.name } })
        this.downloadFile(item)
        // window.open(item.url, '_blank')
      }
    },
    // 打开或关闭右侧导航菜单
    showPopup () {
      this.showpopup = !this.showpopup
    },
    // 滚动到对应的盒子
    scroll (e) {
      const height = e === 'fileD' ? this.$refs.fileD.offsetTop : this.$refs[e][0].offsetTop
      this.$nextTick(() => {
        window.scrollTo(top, height)
      })
      this.showpopup = false
    },
    itemShow (item) {
      this.$set(item, 'show', true)
    },
    showSchool (item) {
      this.$set(item, 'showSchool', true)
    },
    // makePdf () {
    //   const origin = window.location.origin
    //   let baseUrl
    //   if (process.env.NODE_ENV === 'development') {
    //     baseUrl = process.env.VUE_APP_BASE_API
    //   } else {
    //     if (origin.indexOf('-testserver') > -1) {
    //       baseUrl = process.env.VUE_APP_BASE_API_DEV
    //     } else {
    //       baseUrl = process.env.VUE_APP_BASE_API_MASTER
    //     }
    //   }
    //   const url = `${baseUrl}/course/query/share/pdf?id=${this.courseId}`
    //   console.log('url: ', url)
    //   window.open(url)
    // },
    handleDown (item) {
      const link = document.createElement('a')
      // 这里是将url转成blob地址，
      fetch(item.url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        link.href = URL.createObjectURL(blob)
        link.download = 'pic'
        document.body.appendChild(link)
        link.click()
      })
    },
    download (id) {
      return html2canvas(document.getElementById(`${id}`), {
        onrendered: function (canvas) {
          document.getElementById(`${id}`).append(canvas)
          document.getElementById(`${id}`).css('padding', '20px')
        }
      }).then(() => {
        const PDF = new JsPDF('', 'pt', 'a4')
        PDF.addHTML(document.getElementById(`${id}`), { pagesplit: true }, function () {
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            PDF.output('dataurlnewwindow')
          } else {
            PDF.save('ces')
          }
        })
      })
    },
    isSplit (nodes, index, pageHeight) {
      return !!(nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight && nodes[index + 1] && nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight)
    },
    getFooterElement (remainingHeight, fillingHeight = 85) {
      const newNode = document.createElement('div')
      newNode.style.width = 'calc(100% + 8px)'
      newNode.style.marginLeft = '-4px'
      newNode.style.marginBottom = '0px'
      newNode.style.borderTop = '1px solid #7F7F7F'
      newNode.style.height = (remainingHeight + fillingHeight) + 'px' // pdf截断需要一个空白位置
      return newNode
    },
    async downloadPDF () {
      if (this.course.allAttachmentsArray && this.course.allAttachmentsArray.length) {
        this.loading = true
        const obj = this.course.allAttachmentsArray.find(item => item.str.indexOf('项目大纲 Syllabus') > -1)
        const obj1 = this.course.allAttachmentsArray.find(item => item.str.indexOf('项目课表 Tentative Schedule') > -1)
        if (obj) {
          const result = await axios.post('https://gec-api.gecacademy.cn/pdf/pdf2Image', { fileUrl: obj.url })
          this.imglist1 = result.data.data.ossUrl
          this.imglist1 = this.group(this.imglist1, 2)
        }
        if (obj1) {
          const result = await axios.post('https://gec-api.gecacademy.cn/pdf/pdf2Image', { fileUrl: obj1.url })
          this.imglist2 = result.data.data.ossUrl
          this.imglist2 = this.group(this.imglist2, 2)
        }
        this.$nextTick(() => {
          if ((obj && this.imglist1.length) || (obj1 && this.imglist2.length)) {
            const options = {
              className: 'pdfitem'
            }
            this.getPdf(options)
          } else {
            const options = {
              className: 'pdfitem'
            }
            this.getPdf(options)
          }
        })
      } else {
        const options = {
          className: 'pdfitem'
        }
        this.getPdf(options)
      }
    },
    // 附件下载数组重组
    group (array, subGroupLength) {
      let index = 0
      const newArray = []
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength))
      }
      return newArray
    },
    base64ToFile (data) {
      const binary = atob(data.split(',')[1])
      const mime = data.split(',')[0].match(/:(.*?);/)[1]
      const array = []
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i))
      }
      const fileData = new Blob([new Uint8Array(array)], {
        type: mime
      })

      const file = new File([fileData], `${new Date().getTime()}.png`, { type: mime })

      return file
    },
    getPdf (options) {
      const children = document.getElementsByClassName(options.className)
      const i = 0
      this.loading = true
      this.toCanvas(children, i)
    },
    convertBase64UrlToBlob (urlData) {
      var arr = urlData.split(',')
      var _arr = arr[1].substring(0, arr[1].length - 2)
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(_arr)
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    async toCanvas (children, i) {
      const opts = {
        scale: 2, // 缩放比例，提高生成图片清晰度，不推荐太高
        useCORS: true, // 允许加载跨域的图片
        dpi: 800 // 处理模糊问题，越高越清晰，文件越大
      }
      if (children.length > 1) {
        return html2canvas(children[i], opts).then((res) => {
          res.imgWidth = 595.28
          res.imgHeight = 592.28 / res.width * res.height
          this.canvas.push(res)
          i++
          if (this.canvas.length === children.length) {
            this.paging()
          } else {
            this.toCanvas(children, i)
          }
        })
      }
    },
    /**
   * [根据dom的高度初步进行分页，会将canvas组装为一个二维数组]
   */
    async paging () {
      const imgArr = [[]]
      let pageH = 0// 页面的高度
      let allH = 0// 当前组所有dom的高度和
      let j = 0
      for (let k = 0; k < this.canvas.length; k++) { // 涉及到k--的操作，使用for循环方便
        pageH += this.canvas[k].imgHeight
        if (pageH > 841.89 && this.canvas[k].imgHeight < 841.89) { // 当某个页面装不下下一个dom时，则分页
          imgArr[j][0].allH = allH - this.canvas[k].imgHeight
          allH = pageH = 0
          k--
          j++
          imgArr.push([])
        } else {
          if (this.canvas[k].imgHeight > 841.89) { // 特殊情况：某个dom高度大于了页面高度，特殊处理
            this.canvas[k].topH = 841.89 - (pageH - this.canvas[k].imgHeight)// 该dom顶部距离页面上方的距离
            pageH = (2 * this.canvas[k].imgHeight - pageH) % 841.89
            this.canvas[k].pageH = pageH// 该dom底部距离页面上方的距离
          }
          imgArr[j].push(this.canvas[k])
          allH += this.canvas[k].imgHeight
        }
        if (k === this.canvas.length - 1) imgArr[j][0].allH = allH
      }
      this.canvas = imgArr
      await this.toPdf()
    },
    /**
   * [生成PDF文件]
   */
    async toPdf () {
      const PDF = new JsPDF('l', 'pt', 'a4')
      let flag = false
      this.canvas.forEach((page, index) => {
        page.forEach((img, index1) => {
          if (index !== 0 || index1 !== 0) {
            PDF.addPage()
          }
          const pageWidth = PDF.internal.pageSize.getWidth()
          const pageHeight = PDF.internal.pageSize.getHeight()
          const widthRatio = pageWidth / img.imgWidth
          const heightRatio = pageHeight / img.imgHeight
          const ratio = widthRatio > heightRatio ? heightRatio : widthRatio
          const canvasWidth = img.imgWidth * ratio
          const canvasHeight = img.imgHeight * ratio
          const marginX = (pageWidth - canvasWidth) / 2
          const marginY = (pageHeight - canvasHeight) / 2
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            PDF.addImage(img.toDataURL('image/jpeg', 1), 'jpeg', marginX, marginY, canvasWidth, canvasHeight)
            // window.open(PDF.output('bloburl'))
          } else {
            PDF.addImage(img.toDataURL('image/jpeg', 1), 'jpeg', marginX, marginY, canvasWidth, canvasHeight)
          }
        })
        if (index === this.canvas.length - 1) {
          flag = true
        }
      })
      if (flag) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          const imgFiel = this.base64ToFile(PDF.output('datauristring'))
          var formData = new FormData()
          formData.append('file', imgFiel, this.course.name + '.pdf')
          await axios({
            method: 'post',
            url: 'https://studentmanageapi.gecacademy.cn/requirement/uploadFile',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: formData
          })
            .then(res => {
              this.loading = false
              window.location.href = res.data.data.ossUrl
            })
            .catch(err => {
              this.loading = false
              console.log('错误', err)
            })
        } else {
          this.loading = false
          PDF.save(this.course.name)
          // PDF.addImage(img.toDataURL('image/jpeg', 1), 'jpeg', marginX, marginY, canvasWidth, canvasHeight)
        }
        // PDF.save(this.course.name)
      }
    },
    goLink () {
      window.location.href = this.linkurl
    },
    async downloadFile (item) {
      if (item.url.indexOf('gecacademy.oss') > -1 || item.url.indexOf('cdn.gecacademy') > -1) {
        const loading = Toast.loading({
          message: '加载中...',
          forbidClick: true
        })
        const { data } = await generateCourseNewAttachmentUrl({ schoolBegins: this.schoolBegins, teacherName: this.course.teacherName, fileName: item.str, url: item.url })
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = data.newUrl
        a.click()
        loading.clear()
      } else {
        window.open(item.url)
      }
    }
  }
}
